"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
/**
 * A monad which wraps a promise and provides convenient utility methods for working with that promise.
 */
var Async = /** @class */ (function () {
    function Async(value) {
        this.value = value;
    }
    /**
     * Gets the underlying promise, which can then be awaited.
     */
    Async.prototype.get = function () {
        return this.value;
    };
    /**
     * Gets the underlying promise, wrapped in a Result. This is just a shortcut for `Result.ofPromise(Async.get())`
     */
    Async.prototype.getResult = function () {
        return _1.Result.ofPromise(this.value);
    };
    /**
     * Maps the value of the promise to another value.
     */
    Async.prototype.map = function (mapper) {
        return Async.ofPromise(this.value.then(mapper));
    };
    /**
     * Binds the value of the promise to the promise returned by the @param mapper function.
     */
    Async.prototype.bind = function (mapper) {
        return Async.ofPromise(this.value.then(mapper).then(Async.get));
    };
    /**
     * Passes the value to the given @param fn function where it can then be used for work that doesn't require returning a value.
     */
    Async.prototype.iter = function (fn) {
        this.value.then(fn);
        return this;
    };
    /**
     * Creates an Async monad from the promise.
     */
    Async.ofPromise = function (promise) {
        return new Async(promise);
    };
    /**
     * Wraps a non-promise value in an Async monad.
     */
    Async.wrap = function (value) {
        return Async.ofPromise(new Promise(function (res) { return res(value); }));
    };
    /**
     * Gets the underlying promise, which can then be awaited.
     */
    Async.get = function (a) {
        return a.get();
    };
    /**
     * Gets the underlying promise, wrapped in a Result. This is just a shortcut for `Result.ofPromise(Async.get())`
     */
    Async.getResult = function (a) {
        return a.getResult();
    };
    /**
     * Returns a curried function that will map the value of the promise to another value.
     */
    Async.map = function (mapper) {
        return function (a) { return a.map(mapper); };
    };
    /**
     * Returns a curried function that will bind the value of the promise to the promise returned by the @param mapper function.
     */
    Async.bind = function (mapper) {
        return function (a) { return a.bind(mapper); };
    };
    /**
     * Returns a curried function that will pass the value to the given @param fn function where it can then be used for work that doesn't require returning a value.
     */
    Async.iter = function (fn) {
        return function (a) { return a.iter(fn); };
    };
    return Async;
}());
exports.Async = Async;
//# sourceMappingURL=async.js.map